import { render, staticRenderFns } from "./FactBoxBlock.vue?vue&type=template&id=6cbdf181"
import script from "./FactBoxBlock.vue?vue&type=script&lang=js"
export * from "./FactBoxBlock.vue?vue&type=script&lang=js"
import style0 from "./FactBoxBlock.vue?vue&type=style&index=0&id=6cbdf181&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports